/* FAQ: filtro por categoría y búsqueda sobre los <details>; sin JS se ve la lista completa. */
(() => {
  const root = document.querySelector('[data-faq]');
  if (!root) return;
  const items = [...root.querySelectorAll('[data-faq-item]')];
  const tabs = root.querySelector('[data-faq-tabs]');
  const input = root.querySelector('#faq-search');
  const status = root.querySelector('[data-faq-status]');
  const empty = root.querySelector('[data-faq-empty]');
  let cat = '';
  const fold = (s) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  tabs.hidden = false;
  function apply() {
    const q = fold(input.value.trim().toLowerCase());
    let n = 0;
    items.forEach((it) => {
      const show = (!cat || it.dataset.cat === cat) && (!q || fold(it.dataset.search).includes(q));
      it.hidden = !show;
      if (!show) it.open = false;
      if (show) n++;
    });
    empty.hidden = n > 0;
    status.textContent = q ? (n ? status.dataset.lResults.replace('__N__', n) : status.dataset.lNone) : '';
  }
  tabs.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cat]');
    if (!b) return;
    cat = b.dataset.cat;
    tabs.querySelectorAll('[data-cat]').forEach((t) => t.setAttribute('aria-pressed', String(t === b)));
    apply();
  });
  input.addEventListener('input', apply);
  root.querySelector('[data-faq-clear]')?.addEventListener('click', () => {
    input.value = ''; cat = '';
    tabs.querySelectorAll('[data-cat]').forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.cat === '')));
    apply();
  });
})();
